import styled from 'styled-components';
import { theme } from '../../../config/index';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0px;
  ${theme.defaultBoxSizing};
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 100%;
  }
`;

export const LoadingContainer = styled.table`
  position: absolute;
  left: 50%;
  right: 50%;
  z-index: 9999;
`;
